import { useAuthStore } from '@/feature/auth/store/auth'

import { User } from '@/lib/core/interfaces/user.types'

import { useNetworkRequest } from '@/lib/utils/request'

export const useGetUser = (): ReturnType<typeof useNetworkRequest<User>> => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)

  return useNetworkRequest<User>(
    isAuthenticated
      ? {
          url: `v1/auth/users/me/`,
          config: {
            retry: 0,
          },
        }
      : null,
    {
      shouldRetryOnError: false,
      fallbackData: undefined,
    },
  )
}
